export default __webpack_public_path__ + "static/media/1920x1080_Royal_15sec.12538342.mp4";